/*
  Reihenfolge der Aktionen im Kaufbereich.

  Froonze haengt seinen Wunschlisten-Button per JS INS Kaufformular, direkt hinter
  "In den Warenkorb". Damit steht die schwaechste Aktion (merken) zwischen den
  beiden staerkeren (kaufen, anfragen). Dieses Skript setzt sie hinter "Angebot
  machen", sodass die Reihenfolge der Gewichtung folgt:

      kaufen  ->  anfragen  ->  merken

  Warum nicht per CSS: order/flex wirkt nur unter Geschwistern. Der Wunschlisten-
  Wrapper liegt eine Ebene tiefer (im <form>) als der Quotify-Block und laesst
  sich deshalb nicht umsortieren, ohne ihn zu verschieben.
*/
(() => {
  const container = document.querySelector('.product__info-container');
  if (!container) return;

  const place = () => {
    /*
      Bewusst nur greifen, solange der Wrapper NOCH im Formular sitzt. Dadurch ist
      die Funktion idempotent: Nach dem Verschieben findet die Abfrage nichts mehr,
      die vom Verschieben ausgeloeste Mutation laeuft also ins Leere statt in eine
      Endlosschleife.
    */
    const wrap = container.querySelector('form .frcp-wishlist-wrapper');
    if (!wrap) return;

    const quotify = container.querySelector('quotify-button');
    const anchor =
      quotify?.closest('.shopify-app-block') ||
      quotify ||
      /* Ohne Angebotsfunktion: direkt hinter den Block mit dem Kaufformular */
      container.querySelector('product-form')?.parentElement;

    if (!anchor) return;

    /*
      Froonze sucht seinen Button im Formular. Findet er ihn dort nicht mehr —
      weil wir ihn verschoben haben — legt er einen neuen an, und es stuenden
      zwei Wunschlisten untereinander. Deshalb beim Umhaengen die bereits
      verschobenen Exemplare einsammeln und danach entfernen: der frische
      Wrapper gewinnt, denn nur er kennt den aktuellen Zustand
      (hinzufuegen / bereits gemerkt).
    */
    const stale = Array.from(container.querySelectorAll('.frcp-wishlist-wrapper')).filter(
      (el) => el !== wrap && !el.closest('form')
    );

    anchor.after(wrap);
    stale.forEach((el) => el.remove());
  };

  place();

  /* Froonze rendert asynchron und teils erneut (z. B. nach Variantenwechsel) */
  const observer = new MutationObserver(place);
  observer.observe(container, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
